<template>
    <main-layout></main-layout>
</template>

<script>
    import MainLayout from './layouts/MainLayout';

    export default {
        name: 'app',
        components: {
            MainLayout,
        },
        data() {
            return {
                // screen title
                title: 'NowYu.WE',
            };
        },
        watch: {
            /* eslint-disable object-shorthand */
            '$route'(to, from) {
                this.setMeta(to, from);
            },
        },
        methods: {
            setMeta(to) {
                if (typeof document === 'undefined') return;

                document.title = to.meta.window_title;
                this.$store.commit('nav/TITLE', to.meta.title);
            },
        },
    };
</script>

<style lang="stylus">
    @import './stylus/main'
</style>



// WEBPACK FOOTER //
// App.vue?ed2bb604